import "./style.css";

import React from "react";

import PauseIcon from "../../../../../../icons/Pause";
import PlayIcon from "../../../../../../icons/Play";
import VolumeOffIcon from "../../../../../../icons/VolumeOff";
import VolumeUpIcon from "../../../../../../icons/VolumeUp";

interface IAudioActionButtonsProps {
  isPlaying: boolean;
  isMuted: boolean;
  onPlayPause: () => void;
  onMuteUnmute: () => void;
}

const AudioActionButtons: React.FC<IAudioActionButtonsProps> = ({
  isPlaying,
  isMuted,
  onPlayPause,
  onMuteUnmute,
}) => (
  <div className="audio-action-wrapper">
    <button onClick={onPlayPause} className="audio-button">
      {isPlaying ? <PauseIcon /> : <PlayIcon />}
    </button>
    <button onClick={onMuteUnmute} className="audio-button">
      {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
    </button>
  </div>
);

export default AudioActionButtons;
